import QRCode from "qrcode";

export const handleImageError = (event) => {
    event.target.src = "/Images/skash_emptypp.jpg"
  };
  

  export async function generateQr(text) {
    try {
    return await QRCode.toDataURL(text);
   } catch (err) {
    return console.error(err);
   }
  }

  export function utc(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const milliseconds = date.getUTCMilliseconds();
  
    return new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
  }
  